<template>
  <q-layout view="lHh Lpr lFf" class="bg-grey-2">
    <q-page-container>
      <q-page class="q-pa-md bg-grey-2">
        <!-- Header Principal -->
        <q-card class="q-mb-md shadow-2 rounded-borders overflow-hidden">
          <div class="bg-primary text-white q-pa-md row items-center justify-between">
            <div class="row items-center">
              <q-icon name="mark_email_unread" size="md" class="q-mr-sm" />
              <div>
                <div class="text-h6 text-weight-bold">Buzón Electrónico SUNAT SOL</div>
                <div class="text-caption text-blue-2">
                  Monitoreo en tiempo real, ejecuciones coactivas, órdenes de pago y resoluciones
                </div>
              </div>
            </div>
            <q-btn
              color="black"
              icon="terminal"
              label="Ver Traza / Logs cURL"
              unelevated
              size="sm"
              class="text-weight-bold"
              @click="modalLogs.abierto = true"
            />
          </div>
        </q-card>

        <!-- Formulario de Credenciales SOL y Licencia -->
        <q-card class="q-mb-md shadow-2 rounded-borders">
          <q-card-section class="bg-blue-grey-9 text-white q-pa-sm">
            <div class="text-subtitle2 row items-center">
              <q-icon name="admin_panel_settings" class="q-mr-xs" />
              Configuración de Consulta SOL y Licencia de Software
            </div>
          </q-card-section>
          <q-card-section class="q-pa-md">
            <div class="row q-col-gutter-md items-center">
              <div class="col-12 col-sm-3">
                <q-input
                  v-model="formSol.ruc_licencia"
                  outlined
                  dense
                  label="RUC / DNI Licencia"
                  placeholder="20509546411"
                  hint="RUC con el que compró la licencia"
                >
                  <template v-slot:prepend><q-icon name="verified_user" /></template>
                </q-input>
              </div>
              <div class="col-12 col-sm-3">
                <q-input
                  v-model="formSol.ruc_consulta"
                  outlined
                  dense
                  label="RUC Empresa a Consultar"
                  mask="###########"
                  placeholder="20509546411"
                  hint="RUC de la empresa activa"
                >
                  <template v-slot:prepend><q-icon name="business" /></template>
                </q-input>
              </div>
              <div class="col-12 col-sm-2">
                <q-input
                  v-model="formSol.usuario_sol"
                  outlined
                  dense
                  label="Usuario SOL"
                  placeholder="MODDATOS"
                >
                  <template v-slot:prepend><q-icon name="person" /></template>
                </q-input>
              </div>
              <div class="col-12 col-sm-2">
                <q-input
                  v-model="formSol.clave_sol"
                  outlined
                  dense
                  type="password"
                  label="Clave SOL"
                  placeholder="********"
                >
                  <template v-slot:prepend><q-icon name="lock" /></template>
                </q-input>
              </div>
              <div class="col-12 col-sm-2">
                <q-btn
                  color="positive"
                  icon="cloud_download"
                  label="Consultar SOL"
                  unelevated
                  class="full-width text-weight-bold"
                  :loading="cargando"
                  @click="cargarNotificaciones"
                />
              </div>
            </div>
          </q-card-section>
        </q-card>

        <!-- Pantalla / Mensaje de Error HTTP 403 por Licencia No Activa -->
        <q-card v-if="licenciaBloqueada" class="q-mb-md shadow-3 rounded-borders bg-red-1 text-negative border-red">
          <q-card-section class="row items-center">
            <q-avatar color="negative" text-color="white" icon="lock" size="lg" class="q-mr-md" />
            <div class="col">
              <div class="text-h6 text-weight-bold">⚠️ Acceso Restringido: Licencia No Activa (Error HTTP 403)</div>
              <div class="text-subtitle2 q-mt-xs">
                El módulo del Buzón Electrónico SUNAT requiere una <strong>Licencia Activa</strong> para el RUC Licencia:
                <code>{{ formSol.ruc_licencia }}</code>.
              </div>
              <div class="text-caption text-grey-8 q-mt-xs">
                Estado actual de soporte: <strong>{{ estadoSoporteTexto }}</strong>. Active su licencia para acceder a la descarga de notificaciones en tiempo real.
              </div>
            </div>
          </q-card-section>
          <q-separator />
          <q-card-actions align="right" class="q-pa-md">
            <q-btn
              color="negative"
              icon="support_agent"
              label="Contactar Soporte para Activar Licencia"
              unelevated
              class="text-weight-bold"
              @click="abrirSoporte"
            />
            <q-btn
              color="black"
              icon="terminal"
              label="Ver Traza de Diagnóstico"
              flat
              @click="modalLogs.abierto = true"
            />
          </q-card-actions>
        </q-card>

        <!-- Vista Normal (Dashboard + Tabla) -->
        <div v-else>
          <!-- Banner de Alerta si 0 Notificaciones -->
          <q-card v-if="!cargando && notificaciones.length === 0" class="q-mb-md bg-amber-1 text-amber-10 rounded-borders shadow-1">
            <q-card-section class="row items-center justify-between">
              <div class="row items-center">
                <q-icon name="info" size="md" class="q-mr-sm text-warning" />
                <div>
                  <div class="text-weight-bold">No se encontraron notificaciones cargadas en la Base de Datos o SUNAT.</div>
                  <div class="text-caption">Si ingresó credenciales SOL y la pantalla no carga registros, consulte la traza de diagnóstico cURL.</div>
                </div>
              </div>
              <q-btn
                color="black"
                icon="terminal"
                label="Ver Traza / Logs cURL"
                unelevated
                size="sm"
                @click="modalLogs.abierto = true"
              />
            </q-card-section>
          </q-card>

          <!-- Tarjetas de Estadísticas (KPIs) -->
          <div class="row q-col-gutter-md q-mb-md">
            <div class="col-12 col-sm-4">
              <q-card class="shadow-2 rounded-borders bg-white">
                <q-card-section class="row items-center justify-between">
                  <div>
                    <div class="text-caption text-grey-7 text-uppercase text-weight-bold">
                      Total Notificaciones
                    </div>
                    <div class="text-h4 text-weight-bolder text-primary q-mt-xs">
                      {{ kpis.total }}
                    </div>
                  </div>
                  <q-avatar color="blue-1" text-color="primary" icon="mail" size="lg" />
                </q-card-section>
              </q-card>
            </div>

            <div class="col-12 col-sm-4">
              <q-card class="shadow-2 rounded-borders bg-white">
                <q-card-section class="row items-center justify-between">
                  <div>
                    <div class="text-caption text-grey-7 text-uppercase text-weight-bold">
                      Notificaciones Sin Leer
                    </div>
                    <div class="text-h4 text-weight-bolder text-warning q-mt-xs">
                      {{ kpis.noLeidos }}
                    </div>
                  </div>
                  <q-avatar color="amber-1" text-color="warning" icon="mark_email_unread" size="lg" />
                </q-card-section>
              </q-card>
            </div>

            <div class="col-12 col-sm-4">
              <q-card class="shadow-2 rounded-borders bg-white" :class="{ 'bg-red-1': kpis.criticos > 0 }">
                <q-card-section class="row items-center justify-between">
                  <div>
                    <div class="text-caption text-grey-7 text-uppercase text-weight-bold">
                      Alertas Críticas / Coactivas / O.P.
                    </div>
                    <div class="text-h4 text-weight-bolder text-negative q-mt-xs">
                      {{ kpis.criticos }}
                    </div>
                  </div>
                  <q-avatar color="red-1" text-color="negative" icon="warning" size="lg" />
                </q-card-section>
              </q-card>
            </div>
          </div>

          <!-- Barra de Filtros -->
          <q-card class="q-mb-md shadow-2 rounded-borders">
            <q-card-section class="q-pa-md">
              <div class="row q-col-gutter-md items-center justify-between">
                <div class="col-12 col-md-6">
                  <q-input
                    v-model="filtroTexto"
                    outlined
                    dense
                    placeholder="Buscar por Asunto, N° de Resolución o Código..."
                    clearable
                  >
                    <template v-slot:prepend>
                      <q-icon name="search" />
                    </template>
                  </q-input>
                </div>
                <div class="col-12 col-md-6 row justify-end q-gutter-sm">
                  <q-btn-toggle
                    v-model="filtroEstado"
                    toggle-color="primary"
                    flat
                    bordered
                    dense
                    :options="[
                      { label: 'Todas', value: 'TODAS' },
                      { label: '✉️ Sin Leer', value: 'NO_LEIDOS' },
                      { label: '🔴 Solo Críticas', value: 'CRITICOS' }
                    ]"
                  />
                </div>
              </div>
            </q-card-section>
          </q-card>

          <!-- Tabla Principal de Notificaciones -->
          <q-card class="shadow-2 rounded-borders">
            <q-table
              :data="notificacionesFiltradas"
              :columns="columnas"
              row-key="codMensaje"
              :loading="cargando"
              flat
              bordered
              :pagination.sync="pagination"
              @row-click="(evt, row) => abrirDetalleModal(row)"
            >
              <template v-slot:body-cell-nivelRiesgo="props">
                <q-td :props="props">
                  <q-chip
                    v-if="props.row.nivelRiesgo === 'CRITICO'"
                    color="negative"
                    text-color="white"
                    icon="report_problem"
                    dense
                    class="text-weight-bold"
                  >
                    🔴 CRÍTICO
                  </q-chip>
                  <q-chip
                    v-else-if="props.row.nivelRiesgo === 'MODERADO'"
                    color="warning"
                    text-color="black"
                    icon="assignment_late"
                    dense
                    class="text-weight-bold"
                  >
                    🟡 MODERADO
                  </q-chip>
                  <q-chip
                    v-else
                    color="positive"
                    text-color="white"
                    icon="info"
                    dense
                  >
                    🟢 INFORMATIVO
                  </q-chip>
                </q-td>
              </template>

              <template v-slot:body-cell-indEstado="props">
                <q-td :props="props">
                  <q-badge
                    :color="props.row.indEstado === 1 ? 'warning' : 'grey-5'"
                    :label="props.row.indEstado === 1 ? 'Sin Leer' : 'Leído'"
                    class="q-pa-xs"
                  />
                </q-td>
              </template>

              <template v-slot:body-cell-acciones="props">
                <q-td :props="props" class="text-right">
                  <q-btn
                    color="primary"
                    icon="picture_as_pdf"
                    label="Ver / Descargar PDF"
                    dense
                    unelevated
                    size="sm"
                    class="q-mr-xs"
                    @click.stop="verDocumento(props.row)"
                  />
                  <q-btn
                    color="secondary"
                    icon="visibility"
                    label="Detalle"
                    dense
                    unelevated
                    size="sm"
                    @click.stop="abrirDetalleModal(props.row)"
                  />
                </q-td>
              </template>
            </q-table>
          </q-card>
        </div>

        <!-- Modal Terminal de Logs de Diagnóstico (q-dialog) -->
        <q-dialog v-model="modalLogs.abierto">
          <q-card style="width: 800px; max-width: 95vw;" class="bg-grey-10 text-white rounded-borders shadow-4">
            <q-card-section class="bg-black text-green row items-center justify-between">
              <div class="row items-center">
                <q-icon name="terminal" size="md" class="q-mr-sm" />
                <div class="text-h6 text-weight-bold">Traza de Diagnóstico cURL / SUNAT SOL</div>
              </div>
              <q-btn icon="close" flat round dense v-close-popup class="text-white" />
            </q-card-section>
            <q-separator color="grey-8" />
            <q-card-section class="q-pa-md style-terminal-body">
              <div v-if="trazaLogs.length === 0" class="text-grey-5 italic">
                No hay traza registrada. Presione "Consultar SOL" para ejecutar la traza cURL.
              </div>
              <div v-else class="q-gutter-xs">
                <div v-for="(line, idx) in trazaLogs" :key="idx" class="terminal-line">
                  {{ line }}
                </div>
              </div>
            </q-card-section>
            <q-card-actions align="right" class="bg-black q-pa-sm">
              <q-btn flat label="Copiar Logs" color="positive" icon="content_copy" size="sm" @click="copiarLogs" />
              <q-btn flat label="Cerrar" color="white" v-close-popup size="sm" />
            </q-card-actions>
          </q-card>
        </q-dialog>

        <!-- Modal Elegante de Detalle (q-dialog) -->
        <q-dialog v-model="modalDetalle.abierto" transition-show="scale" transition-hide="scale">
          <q-card style="width: 700px; max-width: 90vw;" class="rounded-borders shadow-4">
            <q-card-section class="bg-blue-grey-10 text-white row items-center justify-between">
              <div class="row items-center">
                <q-icon name="description" size="md" class="q-mr-sm" />
                <div class="text-h6 text-weight-bold">Detalle de Notificación SUNAT</div>
              </div>
              <q-btn icon="close" flat round dense v-close-popup />
            </q-card-section>

            <q-card-section class="q-pa-md" v-if="modalDetalle.notificacion">
              <div class="row items-center justify-between q-mb-md">
                <q-chip
                  v-if="modalDetalle.notificacion.nivelRiesgo === 'CRITICO'"
                  color="negative"
                  text-color="white"
                  icon="report_problem"
                  class="text-weight-bold"
                >
                  🔴 NOTIFICACIÓN CRÍTICA (Acción Coactiva / O.P.)
                </q-chip>
                <q-chip
                  v-else
                  color="positive"
                  text-color="white"
                  icon="check_circle"
                >
                  🟢 INFORMATIVA
                </q-chip>

                <q-badge color="grey-8" class="q-pa-xs">
                  Cod. Mensaje: {{ modalDetalle.notificacion.codMensaje }}
                </q-badge>
              </div>

              <!-- Contenido Principal -->
              <div class="text-subtitle1 text-weight-bold text-primary q-mb-xs">
                {{ modalDetalle.notificacion.desAsunto }}
              </div>

              <q-separator class="q-my-sm" />

              <div class="row q-col-gutter-sm q-mt-xs">
                <div class="col-12 col-sm-6">
                  <div class="text-caption text-grey-7 text-weight-bold">N° de Documento / Resolución:</div>
                  <div class="text-body2 text-weight-bolder">{{ modalDetalle.notificacion.numDoc || "S/N" }}</div>
                </div>
                <div class="col-12 col-sm-6">
                  <div class="text-caption text-grey-7 text-weight-bold">Tipo de Acto:</div>
                  <div class="text-body2 text-weight-bolder">{{ modalDetalle.notificacion.tipoDoc || "Notificación SOL" }}</div>
                </div>
                <div class="col-12 col-sm-6">
                  <div class="text-caption text-grey-7 text-weight-bold">Dependencia SUNAT:</div>
                  <div class="text-body2">{{ modalDetalle.notificacion.dependencia || "SUNAT Central" }}</div>
                </div>
                <div class="col-12 col-sm-6">
                  <div class="text-caption text-grey-7 text-weight-bold">Emisor / Área:</div>
                  <div class="text-body2">{{ modalDetalle.notificacion.emisor || "Intendencia SUNAT" }}</div>
                </div>
                <div class="col-12 col-sm-6">
                  <div class="text-caption text-grey-7 text-weight-bold">Fecha de Depósito / Envío:</div>
                  <div class="text-body2">{{ modalDetalle.notificacion.fecEnvio }}</div>
                </div>
                <div class="col-12 col-sm-6">
                  <div class="text-caption text-grey-7 text-weight-bold">Fecha de Publicación Oficial:</div>
                  <div class="text-body2">{{ modalDetalle.notificacion.fecPublica }}</div>
                </div>
              </div>
            </q-card-section>

            <q-card-actions align="right" class="q-pa-md bg-grey-2">
              <q-btn
                v-if="modalDetalle.notificacion && modalDetalle.notificacion.urlPdf"
                color="primary"
                icon="picture_as_pdf"
                label="Ver Documento Completo"
                unelevated
                @click="verDocumento(modalDetalle.notificacion)"
              />
              <q-btn flat label="Cerrar" color="grey-8" v-close-popup />
            </q-card-actions>
          </q-card>
        </q-dialog>

        <!-- Modal Visor PDF / HTML -->
        <q-dialog v-model="modalDocumento.abierto" maximized transition-show="slide-up" transition-hide="slide-down">
          <q-card class="bg-white">
            <q-bar class="bg-primary text-white">
              <q-icon name="picture_as_pdf" />
              <div>Documento SUNAT SOL - {{ modalDocumento.titulo }}</div>
              <q-space />
              <q-btn
                color="white"
                text-color="primary"
                icon="download"
                label="Descargar / Abrir en pestaña nueva"
                dense
                unelevated
                size="sm"
                class="q-mr-md text-weight-bold"
                @click="abrirUrlNuevaPestana(modalDocumento.url)"
              />
              <q-btn dense flat icon="close" v-close-popup />
            </q-bar>
            <q-card-section class="q-pa-none style-iframe-container">
              <iframe :src="modalDocumento.url" width="100%" height="100%" style="border:none;"></iframe>
            </q-card-section>
          </q-card>
        </q-dialog>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import axios from "axios";

export default {
  name: "BuzonSunatView",
  data() {
    return {
      cargando: false,
      licenciaBloqueada: false,
      estadoSoporteTexto: "",
      filtroTexto: "",
      filtroEstado: "TODAS",
      apiUrlCustom: "https://wpagos.aveoperu.com/api/ApiWeb/BuzonSunatApi.php",
      formSol: {
        ruc_licencia: "20509546411",
        ruc_consulta: "20509546411",
        usuario_sol: "MODDATOS",
        clave_sol: "MODDATOS",
        license_key: "DEMO-FREE-MODE-KEY"
      },
      notificaciones: [],
      trazaLogs: [],
      pagination: {
        rowsPerPage: 15
      },
      kpis: {
        total: 0,
        noLeidos: 0,
        criticos: 0
      },
      modalLogs: {
        abierto: false
      },
      modalDetalle: {
        abierto: false,
        notificacion: null
      },
      modalDocumento: {
        abierto: false,
        titulo: "",
        url: ""
      },
      columnas: [
        { name: "nivelRiesgo", label: "Nivel Riesgo", field: "nivelRiesgo", align: "left", sortable: true },
        { name: "indEstado", label: "Estado", field: "indEstado", align: "center", sortable: true },
        { name: "fecPublica", label: "Fecha Notificación", field: "fecPublica", align: "left", sortable: true },
        { name: "desAsunto", label: "Asunto / Descripción del Acto Administrativo", field: "desAsunto", align: "left", sortable: true },
        { name: "acciones", label: "Acciones", field: "acciones", align: "right" }
      ]
    };
  },
  computed: {
    notificacionesFiltradas() {
      return this.notificaciones.filter(item => {
        const textoMatch = !this.filtroTexto || item.desAsunto.toLowerCase().includes(this.filtroTexto.toLowerCase());
        let estadoMatch = true;

        if (this.filtroEstado === "NO_LEIDOS") {
          estadoMatch = item.indEstado === 1;
        } else if (this.filtroEstado === "CRITICOS") {
          estadoMatch = item.nivelRiesgo === "CRITICO";
        }

        return textoMatch && estadoMatch;
      });
    }
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("ruc")) {
      this.formSol.ruc_licencia = urlParams.get("ruc");
      this.formSol.ruc_consulta = urlParams.get("ruc");
    }
    if (urlParams.get("ruc_licencia")) this.formSol.ruc_licencia = urlParams.get("ruc_licencia");
    if (urlParams.get("ruc_consulta")) this.formSol.ruc_consulta = urlParams.get("ruc_consulta");
    if (urlParams.get("license_key")) this.formSol.license_key = urlParams.get("license_key");

    if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
      this.apiUrlCustom = "http://localhost/wpagos/backend/ApiWeb/BuzonSunatApi.php";
    }

    this.cargarNotificaciones();
  },
  methods: {
    async cargarNotificaciones() {
      this.cargando = true;
      this.licenciaBloqueada = false;
      this.trazaLogs = [];
      try {
        const endpointUrl = this.apiUrlCustom.startsWith("http")
          ? this.apiUrlCustom
          : `http://localhost/wpagos/backend/ApiWeb/BuzonSunatApi.php`;

        const response = await axios.create().post(endpointUrl, {
          ruc_licencia: this.formSol.ruc_licencia,
          ruc_consulta: this.formSol.ruc_consulta,
          usuario_sol: this.formSol.usuario_sol,
          clave_sol: this.formSol.clave_sol,
          license_key: this.formSol.license_key,
          accion: "notificaciones"
        });

        if (response.data) {
          if (response.data.traza_logs) {
            this.trazaLogs = response.data.traza_logs;
          }

          if (!response.data.error) {
            this.notificaciones = response.data.rows || [];
            this.kpis.total = response.data.total_records || this.notificaciones.length;
            this.kpis.noLeidos = response.data.total_no_leidos || 0;
            this.kpis.criticos = response.data.total_criticos || 0;
          }
        }
      } catch (err) {
        if (err.response) {
          if (err.response.data && err.response.data.traza_logs) {
            this.trazaLogs = err.response.data.traza_logs;
          }
          if (err.response.status === 403) {
            this.licenciaBloqueada = true;
            this.estadoSoporteTexto = (err.response.data && err.response.data.estado_soporte) ? err.response.data.estado_soporte : "DEMO / INACTIVO";
          }
        } else {
          this.trazaLogs.push(`❌ Error de red / JS: ${err.message}`);
        }
      } finally {
        this.cargando = false;
      }
    },
    abrirDetalleModal(row) {
      this.modalDetalle.notificacion = row;
      this.modalDetalle.abierto = true;
    },
    verDocumento(row) {
      if (row.urlPdf) {
        this.modalDocumento.titulo = row.desAsunto;
        this.modalDocumento.url = row.urlPdf;
        this.modalDocumento.abierto = true;
      } else {
        this.abrirDetalleModal(row);
      }
    },
    abrirUrlNuevaPestana(url) {
      if (url) window.open(url, "_blank");
    },
    copiarLogs() {
      const text = this.trazaLogs.join("\n");
      navigator.clipboard.writeText(text).then(() => {
        alert("Logs copiados al portapapeles.");
      });
    },
    abrirSoporte() {
      window.open("https://wa.me/51999999999?text=Hola,%20deseo%20activar%20mi%20licencia%20para%20el%20Buzon%20SUNAT", "_blank");
    }
  }
};
</script>

<style scoped>
.style-iframe-container {
  height: calc(100vh - 50px);
}
.border-red {
  border: 2px solid #e53935;
}
.style-terminal-body {
  font-family: 'Consolas', 'Courier New', monospace;
  font-size: 13px;
  background-color: #121212;
  max-height: 450px;
  overflow-y: auto;
  border-radius: 4px;
}
.terminal-line {
  line-height: 1.5;
  color: #00e676;
}
</style>
